import React from 'react';
import { Input } from 'antd';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { push } from 'react-router-redux';

import { actions as searchActions } from 'ducks/search';

const enhance = compose(
  connect(
    null,
    {
      push,
      search: searchActions.search,
    }
  ),
);

const Search = props => {
  return (
    <Input.Search
      placeholder="Search..."
      style={{ width: 200 }}
      onSearch={value => {
        props.search(value);
        props.push(`/search?q=${value}`);
      }}
    />
  );
};

export default enhance(Search);



// WEBPACK FOOTER //
// ./src/components/Nav/Search/index.js